"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.position = exports.default = exports.adjustForWindow = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../hooks");
var _external = require("../../external");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const position = exports.position = {
  btmCenter: "btm-center",
  btmLeft: "btm-left",
  btmRight: "btm-right",
  left: "left",
  right: "right",
  topCenter: "top-center",
  topLeft: "top-left",
  topRight: "top-right"
};
const getPositionStyle = (pos, wrapperNode) => {
  if (!wrapperNode) {
    return null;
  }
  const dimensions = wrapperNode.getBoundingClientRect();
  const {
    x,
    y,
    height,
    width
  } = dimensions;
  let left = x + window.scrollX || 0;
  let top = y + window.scrollY || 0;
  switch (pos) {
    case "btm-center":
      left += width / 2;
      top += height;
      break;
    case "btm-left":
      top += height;
      break;
    case "btm-right":
      left += width;
      top += height;
      break;
    case "left":
      top += height / 2;
      break;
    case "right":
      left += width;
      top += height / 2;
      break;
    case "top-center":
      left += width / 2;
      break;
    case "top-left":
      break;
    case "top-right":
      left += width;
      break;
    default:
      break;
  }
  return {
    position: "absolute",
    left,
    top
  };
};
const adjustForWindow = (position, fitsWindow) => {
  let newPosition = position;
  if (!fitsWindow.fromLeft.fitsLeft && newPosition === "left") {
    newPosition = "top-right";
  }
  if (!fitsWindow.fromRight.fitsRight && newPosition === "right") {
    newPosition = "top-left";
  }
  if (!fitsWindow.fromRight.fitsLeft && newPosition.endsWith("-right")) {
    newPosition = newPosition.replace("right", "left");
  }
  if (!fitsWindow.fromLeft.fitsRight && newPosition.endsWith("-left")) {
    newPosition = newPosition.replace("left", "right");
  }
  if (!fitsWindow.fromTop.fitsAbove && newPosition.startsWith("top")) {
    newPosition = newPosition.replace("top", "btm");
  }
  if (!fitsWindow.fromBottom.fitsBelow && newPosition.startsWith("btm")) {
    newPosition = newPosition.replace("btm", "top");
  }
  if (!fitsWindow.fromLeft.fitsRight && !fitsWindow.fromRight.fitsLeft && (newPosition.endsWith("-left") || newPosition.endsWith("-right"))) {
    newPosition = newPosition.replace("left", "center").replace("right", "center");
  }
  if (newPosition.endsWith("center") && (fitsWindow.fromCenter.fitsCentered.fitsRight || fitsWindow.fromCenter.fitsCentered.fitsLeft)) {
    if (!fitsWindow.fromCenter.fitsCentered.fitsRight) {
      newPosition = newPosition.replace("center", "right");
    }
    if (!fitsWindow.fromCenter.fitsCentered.fitsLeft) {
      newPosition = newPosition.replace("center", "left");
    }
  }
  return newPosition;
};

/**
 * This is the [React](https://reactjs.org/) component for Vanilla [Tooltips](https://vanillaframework.io/docs/patterns/tooltips).
 *
 * Tooltips are text labels that appear when the user hovers over, focuses on, or touches an element on the screen.
 *
 * They can be used to provide information about concepts/terms/actions that are not self-explanatory or well known.
 *
 * An alternative use of tooltips is to provide information on a disabled actionable element, e.g. for disabled buttons, providing information about why they are disabled.
 */
exports.adjustForWindow = adjustForWindow;
const Tooltip = _ref => {
  let {
    autoAdjust = true,
    children,
    className,
    followMouse = false,
    message,
    position = "top-left",
    positionElementClassName,
    tooltipClassName,
    zIndex,
    delay = 350
  } = _ref;
  const wrapperRef = (0, _react.useRef)(null);
  const messageRef = (0, _react.useRef)(null);
  const [adjustedPosition, setAdjustedPosition] = (0, _react.useState)(position);
  const [positionStyle, setPositionStyle] = (0, _react.useState)({
    position: "absolute",
    // Initially position the tooltip of the screen in case it gets shown
    // before setting the position.
    left: -9999999,
    top: -9999999
  });
  const {
    openPortal,
    closePortal,
    isOpen,
    Portal
  } = (0, _external.usePortal)({
    programmaticallyOpen: true
  });
  const tooltipId = (0, _react.useId)();
  const [timer, setTimer] = (0, _react.useState)(null);
  const cancelableClosePortal = (0, _react.useCallback)(() => {
    clearTimeout(timer);
    closePortal();
  }, [timer, closePortal]);
  (0, _react.useEffect)(() => {
    if (isOpen && !followMouse && wrapperRef.current) {
      // Position the tooltip when it becomes visible.
      setPositionStyle(getPositionStyle(adjustedPosition, wrapperRef.current));
    }
  }, [adjustedPosition, isOpen, followMouse]);
  const mouseHandler = (0, _react.useCallback)(evt => {
    // Set the position of the tooltip next to the mouse.
    setPositionStyle({
      // Don't allow the tooltip to block the mouse events.
      pointerEvents: "none",
      position: "absolute",
      left: evt.pageX,
      top: evt.pageY
    });
  }, []);
  const onUpdateWindowFitment = (0, _react.useCallback)(fitsWindow => {
    setAdjustedPosition(adjustForWindow(position, fitsWindow));
  }, [setAdjustedPosition, position]);

  // Handle mouse events.
  (0, _hooks.useListener)(wrapperRef.current, mouseHandler, "mousemove", true, followMouse && isOpen);

  // Handle adjusting the position of the tooltip so that it remains on screen.
  (0, _hooks.useWindowFitment)(messageRef.current, wrapperRef.current, onUpdateWindowFitment, 20, isOpen, autoAdjust && followMouse);
  const handleKeyPress = (0, _react.useCallback)(event => {
    if (event.key === "Escape") {
      cancelableClosePortal();
    }
  }, [cancelableClosePortal]);
  (0, _react.useEffect)(() => {
    window.addEventListener("keypress", handleKeyPress);
    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, [handleKeyPress]);
  const handleBlur = e => {
    var _wrapperRef$current, _messageRef$current, _wrapperRef$current2;
    // do not close if the focus is within the tooltip wrapper
    if (wrapperRef !== null && wrapperRef !== void 0 && (_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(document.activeElement)) {
      return;
    }
    if (e.relatedTarget ? !((_messageRef$current = messageRef.current) !== null && _messageRef$current !== void 0 && _messageRef$current.contains(e.relatedTarget)) && !((_wrapperRef$current2 = wrapperRef.current) !== null && _wrapperRef$current2 !== void 0 && _wrapperRef$current2.contains(e.relatedTarget)) : e.target !== messageRef.current) {
      cancelableClosePortal();
    }
  };
  const handleClick = e => {
    var _messageRef$current2;
    // ignore clicks within the tooltip message
    if ((_messageRef$current2 = messageRef.current) !== null && _messageRef$current2 !== void 0 && _messageRef$current2.contains(e.target)) {
      return;
    }
    e.target.focus();
    openPortal();
  };
  const delayedOpenPortal = (0, _react.useCallback)(() => {
    if (isOpen) {
      return;
    }
    if (timer) {
      clearTimeout(timer);
    }
    const timeout = setTimeout(() => openPortal(), delay);
    setTimer(timeout);
  }, [delay, openPortal, timer, isOpen]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, message ? /*#__PURE__*/_react.default.createElement("span", {
    className: className,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: openPortal,
    onMouseOut: handleBlur,
    onMouseOver: delayedOpenPortal
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: positionElementClassName,
    ref: wrapperRef,
    style: {
      display: "inline-block"
    }
  }, _react.default.Children.map(children, child => child && /*#__PURE__*/_react.default.isValidElement(child) ? /*#__PURE__*/_react.default.cloneElement(child, {
    "aria-describedby": isOpen ? tooltipId : undefined
  }) : child)), isOpen ? /*#__PURE__*/_react.default.createElement(Portal, null, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("p-tooltip--".concat(adjustedPosition), "is-detached", tooltipClassName),
    "data-testid": "tooltip-portal",
    style: positionStyle
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "tooltip",
    className: "p-tooltip__message",
    onClick: event => {
      // Prevent clicks inside the message from bubbling to parent
      // click handlers.
      event.stopPropagation();
    },
    ref: messageRef,
    id: tooltipId,
    style: {
      zIndex: zIndex
    }
  }, message))) : null) : /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, children));
};
var _default = exports.default = Tooltip;